module.exports = __webpack_public_path__ + "static/media/success-badge.9426b1b6.png";